<div class="content-wrapper container-xxl p-0 card">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.TITLEE' | translate }}  </h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Users
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text"> {{ 'MENU.DASHBOARD.LIST_TITLEE' | translate }}</p>
          </div>
        </div>
  
           <div class="row d-flex justify-content-between">
           <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" class="mr-2">{{ 'MENU.DASHBOARD.SHOW' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mr-1">{{ 'MENU.DASHBOARD.ENTRIES' | translate }}</span>
              </div>
            </div>
          </div> 
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="">{{ 'MENU.DASHBOARD.SEARCH' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.SEARCH' | translate }}"
                class="form-control form-control-sm w-75"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable
          [rows]="arrCoupons" 
          [rowHeight]="58"
          class="bootstrap core-bootstrap bg-white"
          [limit]="itemsPerPage"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
                      [messages]="{ totalMessage: lang == 'ar' ? 'العدد الكلي' : 'total' }"

        >
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ID' | translate }}"
            prop="id"
            [width]="50"
          ></ngx-datatable-column>
  
          <!-- Image -->
  <ngx-datatable-column name="{{ 'MENU.DASHBOARD.IMAGE' | translate }}" [width]="90">
    <ng-template ngx-datatable-cell-template let-row="row">
      <img
        [src]="row.image"
        alt="onboarding"
        width="50"
        height="50"
        class="rounded"
                (error)="onImgError($event)"

      />
    </ng-template>
  </ngx-datatable-column>

  <!-- Title -->
  <ngx-datatable-column name="{{ 'MENU.DASHBOARD.TITLE' | translate }}" prop="title" [width]="250">
    <ng-template ngx-datatable-cell-template let-row="row">
      <p class="mb-0 font-weight-bold">
        {{ row.title }}
      </p>
    </ng-template>
  </ngx-datatable-column>

  <!-- Description -->
  <ngx-datatable-column name="{{ 'MENU.DASHBOARD.DESCRIPTION' | translate }}" prop="description" [width]="350">
    <ng-template ngx-datatable-cell-template let-row="row">
      <p class="mb-0 ">
        {{ row.description ? (row.description.length > 40 ? (row.description | slice:0:40) + '...' : row.description) : '' }}
      </p>
    </ng-template>
  </ngx-datatable-column>

  <!-- Order -->
  <ngx-datatable-column name="{{ 'MENU.DASHBOARD.ORDER' | translate }}" prop="order" [width]="80">
  </ngx-datatable-column>

  <!-- Updated At -->
  <ngx-datatable-column name="{{ 'MENU.DASHBOARD.DATE' | translate }}" [width]="140">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.updated_at | date: 'dd MMM yyyy' }}
    </ng-template>
  </ngx-datatable-column>
  
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}"
            [width]="100"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div ngbDropdown container="body">
                <button
                  type="button"
                  class="btn btn-sm hide-arrow"
                  ngbDropdownToggle
                >
                  <i data-feather="more-vertical"></i>
                </button>
                <div ngbDropdownMenu>



                    <a ngbDropdownItem (click)="confirmDelete(row.id)">
                    <i data-feather="trash"   [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"></i
                    ><span>{{ "MENU.DASHBOARD.DELETE" | translate }}</span>
                  </a>
                </div>
              </div> 
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable> 
      </section>
    </div>
  </div>
  